import React from "react";
import { useNavigate } from "react-router-dom";
import IndianTaxAdvisorycomponents from "./IndianTaxAdvisorycomponents";
import CallToAction from "./CallToAction";

const IndianTaxAdvisoryInfo = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className="other-pages-main-section indian-tax-fin">
                <h2 className="other-pages-title">Indian Tax Advisory (Direct & Indirect)</h2>
                <p>
                    <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>Home</span> /
                    <span onClick={() => navigate("/indian-tax-advisory")} style={{ cursor: "pointer" }}>Indian Tax Advisory</span>
                </p>
            </div>
            <IndianTaxAdvisorycomponents />
            <CallToAction />
        </>
    );
};

export default IndianTaxAdvisoryInfo;
